<template>
<div>
  <SelectImagePopup
      ref="selectimagepopupref"
      :show="showSelectImage"
      :nameSelected="profile.image"
      @input="onImageSelected"
  />
  <section>
    <div class="left">
      <p @click="showSelectImage()" class="profile_image_box">
        <label for="addLogo" class="profile_image profile" :title="$gettext('Změnit obrázek profilu')"><img
            :key="profile.image" :src="profile.image_path"/></label>
        <a class="btn btn_action btn_edit" :title="$gettext('Změnit obrázek profilu')" v-translate>Změnit obrázek profilu</a>
      </p>
      <detail-entity-info
          :entity="profile"
      >
        <p v-if="profile.device_name"><translate>Vytvořeno na zařízení</translate>: <span class="date"><a @click="onDeviceClick(profile.device_id)">{{ profile.device_name }}</a></span></p>
        <p v-if="profile.name_device_last_used"><translate>Naposledy využito</translate>: <span class="date" v-html="$_date_formatFull(profile.timestamp_last_used)"></span>
          <span><a @click="onDeviceClick(profile.id_device_last_used)">{{ profile.name_device_last_used }}</a></span></p>
      </detail-entity-info>
    </div>
    <div class="right">
      <div class="field_left">
        <text-input id="name"
                    :required="true"
                    v-model="profile.name"
                    ref="nameref"
                    :disabled="!isEditable"
        >
          <translate class="translate">Název</translate>
        </text-input>
      </div>
      <div class="field_right">
        <text-input id="pin"
                    input-type="password"
                    v-model="pin"
                    ref="pinref"
                    @focus="onPinFocus"
                    @blur="onPinBlur"
                    :required="true"
                    :help-text="this.$gettext('minimálně 6 číslic')"
                    :disabled="!isEditable"
        >
          <translate class="translate">PIN profilu</translate>
        </text-input>
        <checkbox-input
            id="tester"
            v-model="profile.force_pin_change"
            ref="forcepinchangeref"
            :disabled="!isEditable"
        >
          <translate class="translate">Vynutit změnu PIN</translate>
        </checkbox-input>
      </div>
      <div class="field_left">
        <checkbox-input
            id="ischild"
            v-model="profile.is_child"
            ref="ischildref"
            :disabled="!isEditable"
        >
          <translate class="translate">Dětský profil</translate>
        </checkbox-input>
        <select-box id="agelimit"
                    v-model="profile.id_maturity_rating"
                    ref="agelimitref"
                    :options="ageLimitOptions"
                    :disabled="!isEditable"
        >
          <translate class="translate">Věkové omezení</translate>
        </select-box>
      </div>

      <div class="field_right">
        <checkbox-input
            id="accesswithpin"
            v-model="accessWithPin"
            ref="accesswithpinref"
            :disabled="!isEditable || !hasPin"
        >
          <translate class="translate">Přístup s PINem</translate>
        </checkbox-input>
        <checkbox-input
            id="editwithpin"
            v-model="profile.security.edit_with_pin"
            ref="editwithpinref"
            :disabled="!isEditable"
        >
          <translate class="translate">Editace s PINem</translate>
        </checkbox-input>
      </div>
      <div class="field_left">
      </div>
    </div>
  </section>

  <section>
    <div class="left">
      <h2 v-translate>Oprávnění</h2>
    </div>
    <div class="right">
      <div class="field_left">
        <select-box id="permissionpvrs"
                    v-model="profile.permissions.pvrs"
                    ref="permissionprvsref"
                    :options="pvrsOptions"
                    :disabled="!isEditable"
        >
          <translate class="translate">Nahrávky</translate>
        </select-box>

        <select-box id="permissionperiodicpvrs"
                    v-model="profile.permissions.periodic_pvrs"
                    ref="permissionperiodicprvsref"
                    :options="pvrsOptions"
                    :disabled="!isEditable"
        >
          <translate class="translate">Pravidelné nahrávky</translate>
        </select-box>

        <select-box id="permissionselfsesrvice"
                    v-model="selfservice"
                    ref="permissionselfserviceref"
                    :options="booleanOptions"
                    :disabled="!isEditable"
        >
          <translate class="translate">Samoobsluha</translate>
        </select-box>
        <select-box id="permissionvod"
                    v-model="vod"
                    ref="permissiovodref"
                    :options="booleanOptions"
                    :disabled="!isEditable"
        >
          <translate class="translate">Videotéka</translate>
        </select-box>
      </div>

      <div class="field_right">
        <select-box id="permissiondevicesettings"
                    v-model="deviceSettings"
                    ref="permissiondevicesettingsref"
                    :options="booleanOptions"
                    :disabled="!isEditable"
        >
          <translate class="translate">Nastavení</translate>
        </select-box>

        <select-box id="permissionmessages"
                    v-model="messages"
                    ref="permissionmessagesref"
                    :options="booleanOptions"
                    :disabled="!isEditable"
        >
          <translate class="translate">Oznámení</translate>
        </select-box>

        <select-box id="permissionchannelgroups"
                    v-model="channelGroups"
                    ref="permissiochannelgroupsref"
                    :options="booleanOptions"
                    :disabled="!isEditable"
        >
          <translate class="translate">Skupiny stanic</translate>
        </select-box>
      </div>

    </div>
  </section>
  <section v-if="profile.id">
    <div class="left">
      <h2 v-translate>Profilová konfigurace</h2>
    </div>
    <div class="right">
      <div class="field">
        <JSONTextareaInput
            v-model="profile.profile_config"
            rows="15"
            :disabled="true"
        >
          <translate class="translate">JSON konfigurace</translate>
        </JSONTextareaInput>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import {getCorrectBooleanValue} from "@/utils/helpers"
import DetailEntityInfo from "../../../common/DetailEntityInfo.vue";
import subscriberProfile from "./../mixins/subscriberProfile";
import JSONTextareaInput from "../../../common/JSONTextareaInput.vue";
import SelectImagePopup from "../SelectImagePopup.vue";
export default {
  components: {SelectImagePopup, JSONTextareaInput, DetailEntityInfo},
  mixins: [subscriberProfile],
  props: {
    profile: Object,
    isEditable: Boolean,
  },
  data(){
    return {
      ageLimitOptions: [],
      pinFocused: false,
    }
  },
  created(SubscriberProfileService){
    this.entityService = SubscriberProfileService;
    this.entityService.getMaturityRatingList()
        .then((data)=>{
          this.ageLimitOptions = data['list'];
          this.ageLimitOptions.forEach(item => {
            if(item.text === 'Všechny věkové kategorie'){
              item.text = this.$gettext('Všechny věkové kategorie');
            }
          });
          if(this.profile && !this.profile.id_maturity_rating){
            this.setDefaultRating();
          }
        });
  },
  computed: {
    pin: {
      get() {
        return this.pinFocused ? this.profile.pin : (this.profile.pin || '******')
      },
      set(value) {
        this.profile.pin = value
      }
    },
    hasPin() {
      // PIN set previously OR PIN set currently
      return this.profile.has_pin || !!this.profile.pin
    },
    accessWithPin: {
      get() {
        return this.hasPin ? this.profile.security.access_with_pin : false
      },
      set(value) {
        this.profile.security.access_with_pin = this.hasPin && value
      }
    },
    pvrsOptions(){
      return [
        {id: 'ALL', text: this.$gettext('Všechny')},
        {id: 'OWN', text: this.$gettext('Vlastní')},
        {id: 'NONE', text: this.$gettext('Žádné')},
      ]
    },
    booleanOptions(){
      return [
        {id: true, text: this.$gettext('Ano')},
        {id: false, text: this.$gettext('Ne')},
      ]
    },
    selfservice: {
      get() {
        return this.profile.permissions.selfservice;
      },
      set(newValue) {
        this.profile.permissions.selfservice = getCorrectBooleanValue(newValue)
      }
    },
    deviceSettings: {
      get() {
        return this.profile.permissions.device_settings;
      },
      set(newValue) {
        this.profile.permissions.device_settings = getCorrectBooleanValue(newValue)
      }
    },
    messages: {
      get() {
        return this.profile.permissions.messages;
      },
      set(newValue) {
        this.profile.permissions.messages = getCorrectBooleanValue(newValue)
      }
    },
    channelGroups: {
      get() {
        return this.profile.permissions.channel_groups;
      },
      set(newValue) {
        this.profile.permissions.channel_groups = getCorrectBooleanValue(newValue)
      }
    },
    vod: {
      get() {
        return this.profile.permissions.vod;
      },
      set(newValue) {
        this.profile.permissions.vod = getCorrectBooleanValue(newValue)
      }
    },
  },
  methods: {
    onPinFocus() {
      this.pinFocused = true
    },
    onPinBlur() {
      this.pinFocused = false
    },
    onDeviceClick(id){
      if(id) {
        this.$router.push({name: 'deviceDetail', params: {id: id}})
      }
    },
    showSelectImage(){
      this.$refs.selectimagepopupref.setShow(true);
    },
    onImageSelected(id, path){
      this.profile.image = id;
      this.profile.image_path = path;
    },
    setDefaultRating(){
      let rating;
      if(this.profile.is_child){
        rating = this.ageLimitOptions.find((item) => item.is_child_default === true);
      }else{
        rating = this.ageLimitOptions.find((item) => item.is_default === true);
      }
      this.profile.id_maturity_rating = rating.id;
    }
  },
  watch: {
    'profile.is_child' () {
      this.setDefaultRating();
    },
    'hasPin' () {
      if(!this.hasPin) {
        this.accessWithPin = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/subscriberProfile/forms/BasicInfo.vue